<template>
  <div id="clock">
    <span class="date">{{ date }} {{ time }}</span>
    <!-- <span class="time">{{ time }}</span> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      week: [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      time: "",
      date: "",
    };
  },
  mounted() {
    this.nowTimes();
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    clear() {
      clearInterval(this.updateTime);
    },
    nowTimes() {
      this.updateTime();
      setInterval(this.updateTime, 1000);
    },
    updateTime() {
      var cd = new Date();
      this.time =
        this.zeroPadding(cd.getHours(), 2) +
        ":" +
        this.zeroPadding(cd.getMinutes(), 2) +
        ":" +
        this.zeroPadding(cd.getSeconds(), 2);

      this.date =
        this.zeroPadding(cd.getFullYear(), 4) +
        "-" +
        this.zeroPadding(cd.getMonth() + 1, 2) +
        "-" +
        this.zeroPadding(cd.getDate(), 2) +
        " " +
        this.week[cd.getDay()];
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
  },
};
</script>
<style scoped>
/* #clock {
  text-align: center;
  position: relative;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  color: #000000;
  font-weight: bold;
}
#clock .time {
  display: block;
  letter-spacing: 0.05em;
  font-size: 54px;
  padding: 5px 0;
} */
#clock .date {
  display: block;
  letter-spacing: 0.1em;
  font-size: 42px;
  font-weight: bold;
  margin-top: 10px;
}
</style>